<template>
  <div class="dashboard-wrapper welcome">
    <component :is="component" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ErrorLoadingSites from '@/components/common/siteCheck/ErrorLoadingSites.vue';
import NoSitesAssignedError from '@/components/common/siteCheck/NoSitesAssignedError.vue';
import ForbiddenSiteError from '@/components/common/siteCheck/ForbiddenSiteError.vue';
import indexIdFromUrlMixin from '@/components/common/siteCheck/mixins/indexIdFromUrlMixin';

export default {
  name: 'SiteAccessError',
  data: () => ({
    errorMap: {
      errorLoadingSites: ErrorLoadingSites,
      noSitesAssigned: NoSitesAssignedError,
      forbiddenSite: ForbiddenSiteError,
    },
  }),
  mixins: [
    indexIdFromUrlMixin,
  ],
  computed: {
    ...mapState('common', [
      'sitesLoaded',
      'siteLoadError',
      'userSites',
    ]),
    ...mapGetters('common', [
      'siteAccessError',
    ]),
    componentType() {
      if (!!this.siteLoadError) {
        return 'errorLoadingSites';
      }
      return this.siteAccessError;
    },
    component() {
      return this.errorMap[this.componentType];
    },
  },
};
</script>

<style scoped>

</style>
